import restoreLogin from './utils/restoreLogin'

// 先恢复登录信息，再加载应用及其依赖。
restoreLogin(() => {
  require('./bootstrap')
})



// WEBPACK FOOTER //
// ./src/main.js